import styled, {css} from "styled-components/macro";
import {PreviewElementStyles} from "./PreviewElement-types";

export const Root = styled.div<PreviewElementStyles>`
    position: absolute;
    
    ${({$baseHeight: baseHeight, $image: image, $parameters: parameters}) => css`
        height: calc(${baseHeight} * ${image.height} / ${parameters.height});
        left: calc(${baseHeight} * ${image.position.x} / ${parameters.width});
        top: calc(${baseHeight} * ${image.position.y} / ${parameters.height});
        z-index: ${image.zIndex || 0};
    `}
`;
